import React from "react";
import "./SelectorButton.css";

const SelectorButton = ({ imageSrc, headerText, subHeaderText, onClick }) => {
  return (
    <div className="selector-button-comp" onClick={onClick}>
      <div className="selector-button-comp-top">
        <img
          src={imageSrc}
          alt={headerText}
          className="selector-button-comp-image"
        />
      </div>
      <div className="selector-button-comp-bottom">
        <h2 className="selector-button-comp-header">{headerText}</h2>
        <p className="selector-button-comp-subheader">{subHeaderText}</p>
      </div>
    </div>
  );
};

export default SelectorButton;
